// extracted by mini-css-extract-plugin
export default {"bottombar":"BottomBar_bottombar__28FZo"};